// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1bFKf","empty":"ModalGraph_empty__LUKTx"};